<template>
  <div class="wrapper-menu">
    <div class="options">
      <router-link to="/sample-book" class="option" v-if="showReferences">
        <img src="@/assets/menu/Sample.svg" alt="" class="icon sample" />
        <span class="option-name">Muestrario</span>
      </router-link>

      <router-link to="/users" class="option" v-if="showUsers">
        <img src="@/assets/menu/Users.svg" alt="" class="icon users" />
        <span class="option-name">Usuarios</span>
      </router-link>

      <router-link to="/banners" class="option" v-if="showBanners">
        <img src="@/assets/menu/Banner.svg" alt="" class="icon banner" />
        <span class="option-name">Banners</span>
      </router-link>

      <router-link to="/news" class="option" v-if="showNews">
        <img src="@/assets/menu/News.svg" alt="" class="icon news" />
        <span class="option-name">Noticias</span>
      </router-link>

      <router-link to="/files" class="option" v-if="showFiles">
        <img src="@/assets/menu/Files.svg" alt="" class="icon files" />
        <span class="option-name">Archivos</span>
      </router-link>

      <router-link to="/notifications" class="option" v-if="false">
        <img
          src="@/assets/menu/Notifications.svg"
          alt=""
          class="icon notifications"
        />
        <span class="option-name">Notificaciones</span>
      </router-link>

      <router-link
        to="/shared-samples"
        class="option"
        v-if="showSharedReferences"
      >
        <img src="@/assets/menu/Shared.svg" alt="" class="icon shared" />
        <span class="option-name">Muestras compartidas</span>
      </router-link>

      <router-link to="/campaigns" class="option" v-if="showCampaigns">
        <img src="@/assets/menu/Campaigns.svg" alt="" class="icon campaigns" />
        <span class="option-name">Campañas</span>
      </router-link>

      <router-link to="/advances" class="option" v-if="showAdvances">
        <img src="@/assets/menu/Advances.svg" alt="" class="icon advances" />
        <span class="option-name">Anticipos</span>
      </router-link>

      <router-link to="/payments" class="option" v-if="showPayments">
        <img src="@/assets/menu/Payments.svg" alt="" class="icon payments" />
        <span class="option-name">Pagos</span>
      </router-link>

      <router-link to="/events" class="option" v-if="showEvents">
        <img src="@/assets/menu/Events.svg" alt="" class="icon events" />
        <span class="option-name">Eventos</span>
      </router-link>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import { UserAuth } from "@/business/auth/domain/login";

export default defineComponent({
  name: "LoginView",
  props: {
    userAuth: {
      type: Object as () => UserAuth,
      required: true,
    },
  },
  setup(props) {
    const showUsers = computed(() => props.userAuth.role == "1");
    const showReferences = computed(
      () => props.userAuth.role == "2" || props.userAuth.role == "5"
    );
    const showBanners = computed(
      () =>
        props.userAuth.role == "1" ||
        props.userAuth.role == "2" ||
        props.userAuth.role == "5"
    );
    const showNews = computed(
      () =>
        props.userAuth.role == "1" ||
        props.userAuth.role == "2" ||
        props.userAuth.role == "5"
    );
    const showFiles = computed(() => props.userAuth.role == "1");
    const showNotifications = computed(() => props.userAuth.role == "1");
    const showSharedReferences = computed(
      () =>
        props.userAuth.role == "1" ||
        props.userAuth.role == "2" ||
        props.userAuth.role == "5"
    );
    const showCampaigns = computed(
      () =>
        props.userAuth.role == "1" ||
        props.userAuth.role == "2" ||
        props.userAuth.role == "5"
    );
    const showAdvances = computed(() => props.userAuth.role == "4");
    const showPayments = computed(() => props.userAuth.role == "4");
    const showEvents = computed(() => props.userAuth.role == "6");

    return {
      showUsers,
      showReferences,
      showBanners,
      showNews,
      showFiles,
      showNotifications,
      showSharedReferences,
      showCampaigns,
      showAdvances,
      showPayments,
      showEvents,
    };
  },
});
</script>

<style scoped lang="scss">
@import "src/ux/layout/styles/menuStyle";
</style>
